import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import {
  useGetEndUserAppleLuckyDrawById,
  usePatchEndUserAppleLuckyDrawReject,
} from '../../../../../api/promotions/end-user/end-user-apple-lucky-draw'

// List of predefined rejection messages
const REJECTION_MESSAGES = [
  `Irrelevant photo`,
  `Serial number entered does not match as shown in photo`,
  `Serial number not readable or visible`,
]

const RejectButton = ({ id }) => {
  const { mutateAsync, isLoading } = usePatchEndUserAppleLuckyDrawReject(id)
  const { refetch } = useGetEndUserAppleLuckyDrawById(id)

  const { enqueueSnackbar } = useSnackbar()

  // Selected reject reason
  const [rejectReason, setRejectReason] = useState('')

  // Dialog
  const [openDialog, setOpenDialog] = useState(false)

  // Open/Close dialog
  const handleClickReject = () => {
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  // Reject
  const handleReject = async () => {
    setOpenDialog(false) // Close the dialog after rejection

    try {
      const res = await mutateAsync({ rejectReason })

      // Display success on popup
      enqueueSnackbar(`Rejected successfully`, {
        variant: 'success',
      })

      // Refresh current data
      refetch()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to reject', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  const handleOnChange = (ev) => {
    setRejectReason(ev.target.value)
  }

  return (
    <>
      {/* Reject button */}
      <Button
        size='large'
        variant='contained'
        color='error'
        onClick={handleClickReject}
        disabled={isLoading}
      >
        Reject
      </Button>
      {/* Confirmation dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
        <DialogTitle>Confirm Rejection</DialogTitle>
        <DialogContent>
          <div>Please select the reason for rejection</div>
          <FormControl fullWidth margin='normal'>
            <InputLabel>Reject Reason</InputLabel>
            <Select value={rejectReason} onChange={handleOnChange} label='Reject Reason' required>
              {REJECTION_MESSAGES.map((message, index) => (
                <MenuItem key={index} value={message}>
                  {message}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          {/* Cancel button */}
          <Button onClick={handleCloseDialog}>Cancel</Button>
          {/* Confirm Reject/Submit button */}
          <Button onClick={handleReject} variant='contained' color='error' disabled={!rejectReason}>
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RejectButton
